<template>
  <el-dialog
    id="invite-member"
    title="Invitation new users"
    top="10vh"
    :width="width"
    :visible.sync="visible"
  >
    <BillingUpgrade v-if="upgrade" request-access="team management" />

    <template v-else>
      <p>Enter the email addresses of the users you'd like to invite and press enter</p>
      <el-form ref="invite" :rules="rules" :model="form">
        <el-form-item prop="emails">
          <el-tag
            v-for="email in form.emails"
            :key="email"
            closable
            :disable-transitions="false"
            @close="remove(email)"
          >
            {{ email }}
          </el-tag>

          <el-input
            v-model="input"
            placeholder="aude@runstack.com, etc. (press enter)"
            class="invite-emails"
            @keyup.enter.native="add"
            @blur="add"
          />
        </el-form-item>

        <el-form-item prop="access">
          <el-table :data="roles" :show-header="false">
            <el-table-column width="150px">
              <template slot-scope="scope">
                <el-radio v-model="form.access" :label="scope.row.access">
                  <strong>{{ scope.row.name }}</strong>
                </el-radio>
              </template>
            </el-table-column>

            <el-table-column prop="description" />
          </el-table>
        </el-form-item>
      </el-form>

      <Quota :client="client" />

      <div slot="footer">
        <el-button
          type="default"
          size="large"
          @click="visible = false"
        >
          Cancel
        </el-button>

        <el-button
          type="primary"
          size="large"
          :loading="loading"
          @click.prevent="invite"
        >
          Invitation
        </el-button>
      </div>
    </template>
  </el-dialog>
</template>

<script>
import { mapState } from 'vuex'
import isEmail from 'validator/lib/isEmail'
import Quota from './Quota'
import BillingUpgrade from '../Billing/Upgrade'

export default {
  props: {
    open: Boolean
  },
  components: {
    Quota,
    BillingUpgrade
  },
  data () {
    const checkEmails = (rule, value, done) => {
      if (!value || value.length === 0) {
        return done('Please input an email address and press enter to validate.')
      }
      const fail = value.findIndex((email) => !isEmail(email.trim()))
      if (fail === -1) {
        return done()
      }
      return done('You entered a wrong email address.')
    }
    return {
      loading: false,
      upgrade: false,
      visible: this.open,
      error: null,
      input: null,
      form: {
        emails: [],
        access: null
      },
      rules: {
        emails: [{ validator: checkEmails, trigger: 'blur' }],
        access: [{ required: true, message: 'Please choose the role they should have', trigger: 'blur' }]
      },
      roles: [{
        access: 2,
        name: 'Administrator',
        description: 'Best for business owners and company administrators.'
      }, {
        access: 4,
        name: 'Manager',
        description: 'Best for employees who need full access to Runstack, but don\'t need to update business settings.'
      }, {
        access: 16,
        name: 'Developer',
        description: 'Best for developers or people primarily using git and builds.'
      }, {
        access: 64,
        name: 'Accounting',
        description: 'Best for people who need to view Billing and Costs, but don\'t need to use Runstack.'
      }]
    }
  },
  computed: {
    width () {
      return this.upgrade ? '1000px' : '600px'
    },
    unavailable () {
      return !this.client || !this.client.team
    },
    ...mapState(['client', 'project'])
  },
  methods: {
    invite () {
      this.$refs.invite.validate((valid) => {
        if (valid) {
          if (this.unavailable) {
            this.upgrade = true
          } else {
            this.loading = true
            this.$store.dispatch('inviteTeam', this.form)
              .then(() => {
                this.visible = false
                this.$emit('change')
              })
          }
        }
      })
    },
    remove (email) {
      this.form.emails.splice(this.form.emails.indexOf(email), 1)
    },
    add () {
      if (this.input) {
        if (!isEmail(this.input.trim())) {
          this.error = 'Please input an email address and press enter to validate.'
          return
        }

        this.form.emails.push(this.input.trim())
        this.input = ''
      }
    }
  },
  watch: {
    open (value) {
      this.visible = value
      this.loading = false
      this.upgrade = false
      this.form = {
        emails: [],
        access: null
      }
    },
    visible (value) {
      this.$nextTick(() => this.$emit('update:open', value))
    },
    unavailable () {
      this.upgrade = false
    }
  }
}
</script>

<style lang="scss">
  #invite-member {
    .cell {
      word-break: break-word;
    }
    .el-tag + .el-tag {
      margin-left: 10px;
    }
  }
</style>
